import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {ICollectionModel} from '../../../model/appModel';
import {MenuItem} from '@techsmith/tsc-cloud-style-guide';
import withMemoizedContexts from '../../../context/contextContainerHoC';
import {collectionsStore} from '../../../context/collectionsProvider';
import {mediaStore} from '../../../context/mediaProvider';

export const CollectionsMenuBase: React.FC<ICollectionsMenuProps & IStateMappedProps> = ({setFilter, collections, CollectionIds}) => {
   const {t} = useTranslation();

   return (
      <>
         <MenuItem
            key={`collections-menu-item-${0}`}
            label={t('analytics.allViewers')}
            onClick={() => setFilter(null)}
            testId="collections-menu-item-all-viewers"
         />
         {collections.filter(c => CollectionIds.find(id => id === c.Id)).map((collection, index) => (
            <MenuItem
               key={`collections-menu-item-${index + 1}`}
               label={collection.Name}
               onClick={() => setFilter(collection)}
               testId="collections-menu-item"
            />
         ))}
      </>
   );
};

export interface ICollectionsMenuProps {
   setFilter(collection: ICollectionModel): void;
}

export interface IStateMappedProps {
   collections: ICollectionModel[];
   CollectionIds: string[];
}

const mapStatesToProps = (
   {setFilter}: ICollectionsMenuProps,
   {collections}: Partial<IStateMappedProps>,
   {CollectionIds}: Partial<IStateMappedProps>
): ICollectionsMenuProps & IStateMappedProps => ({setFilter, collections, CollectionIds});

export default withMemoizedContexts(mapStatesToProps, collectionsStore, mediaStore)(CollectionsMenuBase);
